import Cookies from 'js-cookie'

const TokenKey = 'admin_token'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}
//微信openid
export function getOpenid() {
  return Cookies.get('openid')
}

export function setOpenid(openid) {
  return Cookies.set('openid',openid)
}





// WEBPACK FOOTER //
// ./src/libs/auth.js